import http from 'hub-http/clients/apiClient';
export const fetchNextBestActions = callId => {
  return http.post(`/calling/transcripts/ai/v1/next-actions/${callId}`);
};